module.exports = __webpack_public_path__ + "img/login_logo.f73b2012.png";